import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { getFirestore, serverTimestamp, doc, updateDoc } from "firebase/firestore";
import { app } from '../BD/Config';
import { ref, uploadBytesResumable, getDownloadURL, getStorage, uploadString } from "firebase/storage";
import { nanoid } from 'nanoid';
import { readAndCompressImage } from 'browser-image-resizer';
import './TakePicture.css';

export default function TakePicture({ DocID, NoImg, detalle, onUpload }) {
  const [MdShowtakepicture, setMdShowtakepicture] = useState(false);
  const [Urlmin, setUrlMin] = useState(detalle.UrlMin);
  const [imgUrl, setImgUrl] = useState(null);
  const [progresspercent, setProgresspercent] = useState(0);
  const [TkPicturemin, setTkPicturemin] = useState(null);
  const [ProgrLoading, setProgrLoading] = useState(false);
  const [ImgUp, setImgUp] = useState(null);

  const storage = getStorage(app);
  const db = getFirestore(app);

  const ImgFullHD = { quality: 0.8, maxWidth: 1280, maxHeight: 1280, autoRotate: true, debug: true };
  const ImgMinQuality = { quality: 0.9, maxWidth: 150, maxHeight: 150, autoRotate: true, debug: true };

  const changeHandler = async (e) => {
    if (e.target.files.length > 0) {
      const compressedFileMax = await readAndCompressImage(e.target.files[0], ImgFullHD);

      setMdShowtakepicture(true);
      setProgrLoading(true);
      setImgUp(compressedFileMax);
      setProgresspercent(0);

      setImgUrl(URL.createObjectURL(compressedFileMax));
      const compressedFile = await readAndCompressImage(compressedFileMax, ImgMinQuality);

      const reader = new FileReader();
      reader.onloadend = () => {
        let base64Image = reader.result;
        setTkPicturemin(base64Image);
      };

      reader.readAsDataURL(compressedFile);
      HideLoading();
    }
  };

  const handleSubmit = () => {
    if (!ImgUp) {
      alert("Seleccionar imagen");
      return;
    }
  
    const namefile = nanoid();
    const namefilemin = nanoid();
    const storageRef = ref(storage, `/Products/${namefile}`);
    const storageRefmin = ref(storage, `/ProductsMin/${namefilemin}`);
    const uploadTask = uploadBytesResumable(storageRef, ImgUp);
  
    uploadTask.on("state_changed",
      (snapshot) => {
        const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        setProgresspercent(progress);
      },
      (error) => {
        alert("Revisar resolución de la Cámara, resolución recomendada menor a 16 megapíxeles." + error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setImgUrl(downloadURL);
          uploadString(storageRefmin, TkPicturemin, 'data_url').then((snapshot) => {
            getDownloadURL(storageRefmin).then((urlmin) => {
              onUpload(NoImg, downloadURL, urlmin);
              setUrlMin(urlmin);
            });
          });
        });
      }
    );
  };
  
  const HideLoading = () => {
    setTimeout(() => { setProgrLoading(false); }, 2000);
  };

  const download = (e) => {
    const urlParts = decodeURIComponent(e.target.href).split("/");
    const fileId = urlParts[urlParts.length - 1].split('-')[0];

    fetch(e.target.href, {
      method: "GET",
      headers: {}
    })
      .then(response => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${fileId}.jpg`);
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  return (
    <div className='take-picture-container'>
      <div className='take-picture-content'>
        {Urlmin && <img src={Urlmin} alt="foto" className="take-picture-thumbnail" />}
        <div className='take-picture-menu'>
          <label htmlFor={"inputTag" + NoImg} className='take-picture-option'>
            <img src={process.env.PUBLIC_URL + "/img/picture.png"} className="take-picture-icon" />
            <input type='file' className='take-picture-input' accept="image/*" onChange={changeHandler} id={"inputTag" + NoImg} name={"inputTag" + NoImg} />
          </label>
          {Urlmin && (
            <a href={detalle.Url} download onClick={e => download(e)} target="_blank" className="take-picture-download">
              <i className="fa fa-download" /> Descargar
            </a>
          )}
        </div>
      </div>

      <Modal show={MdShowtakepicture} fullscreen={true} onHide={() => setMdShowtakepicture(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Button variant="outline-info" onClick={() => setMdShowtakepicture(false)}> ❰ Regresar </Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='take-picture-row'>
            <button className='take-picture-button' type="button" style={{ visibility: (imgUrl === null || progresspercent === 100) ? "hidden" : "visible" }} onClick={handleSubmit}>Subir</button>
          </div>

          <div className='take-picture-row'>
            <div className='take-picture-progress-outer'>
              <div className='take-picture-progress-inner' style={{ width: `${progresspercent}%` }}>{progresspercent}%</div>
            </div>
          </div>
          <div className='take-picture-row'>
            {imgUrl && <img src={imgUrl} alt='uploaded file' className='take-picture-upload' />}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
